import _ from "lodash";
import moment from "moment";
import { AUTO_SMS_KEY } from "../../../constants";
import getSMSLogs from "../services/getSMSLogs";

const needFollowUpFilter = () => (clientAppointments) => {
  return _.filter(clientAppointments, (ca) => {
    const logs = getSMSLogs(ca.id, clientAppointments, "sms");
    if (_.isEmpty(logs)) return false;

    let which = "";
    let result = {};
    for (let idx = 0; idx < logs.length; idx++) {
      if (logs[idx]?.name) {
        result[which] = "";
        which = _.startsWith(logs[idx].name, "initial") ? AUTO_SMS_KEY.INITIAL : logs[idx].name;
      }

      if (logs[idx]?.name === AUTO_SMS_KEY.INITIAL_SECOND) {
        // if there is no received yes or no at 8 hours after initial second sms, treat it as patient says no
        if (moment().diff(moment.unix(logs[idx].ts), "hours") >= 8) {
          result[which] = "no_response";
        }
      }

      if (logs[idx].text !== null && logs[idx].patient) {
        if (logs[idx].text.replace(/(\r\n|\n|\r)/gm, " ").search(/\byes\b|\by\b/gi) !== -1) {
          result[which] = "yes";
        } else if (logs[idx].text.replace(/(\r\n|\n|\r)/gm, " ").search(/\bno\b|\bn\b/gi) !== -1) {
          result[which] = "no";
        }
      }
    }
    return result["initial"] === "no" || result["initial"] === "no_response";
  });
};

export default needFollowUpFilter;
